import { render, staticRenderFns } from "./DropupMenu.vue?vue&type=template&id=79087413&scoped=true"
import script from "./DropupMenu.vue?vue&type=script&lang=ts"
export * from "./DropupMenu.vue?vue&type=script&lang=ts"
import style0 from "./DropupMenu.vue?vue&type=style&index=0&id=79087413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79087413",
  null
  
)

export default component.exports